import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef, useState, useEffect } from 'react'
import { motivationalQuotes } from '../data/mockData'
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react'

const Motivation = () => {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, margin: '-100px' })
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % motivationalQuotes.length)
    }, 5000)
    return () => clearInterval(timer)
  }, [])

  const next = () => setCurrent((prev) => (prev + 1) % motivationalQuotes.length)
  const prev = () => setCurrent((prev) => (prev - 1 + motivationalQuotes.length) % motivationalQuotes.length)

  return (
    <section className="py-20 bg-gradient-primary relative overflow-hidden" ref={ref}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="container-custom relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Inspiration Quotidienne</h2>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Des pensées motivantes pour stimuler votre esprit
          </p>
        </motion.div>

        <div className="relative max-w-4xl mx-auto">
          <motion.div
            key={current}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5 }}
            className="bg-white rounded-3xl shadow-2xl p-8 md:p-12"
          >
            <Quote className="w-16 h-16 text-secondary mb-6" />
            <p className="text-2xl md:text-3xl font-heading text-gray-800 mb-6 leading-relaxed">
              {motivationalQuotes[current].quote}
            </p>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-gradient-primary rounded-full flex items-center justify-center text-white font-bold">
                {motivationalQuotes[current].author[0]}
              </div>
              <div>
                <p className="font-semibold text-primary text-lg">{motivationalQuotes[current].author}</p>
                <p className="text-gray-600 text-sm">{motivationalQuotes[current].role}</p>
              </div>
            </div>
          </motion.div>

          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={prev}
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-secondary transition-colors shadow-lg"
            >
              <ChevronLeft className="w-6 h-6 text-primary" />
            </button>

            <div className="flex gap-2">
              {motivationalQuotes.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    i === current ? 'bg-white w-8' : 'bg-white/50'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={next}
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-secondary transition-colors shadow-lg"
            >
              <ChevronRight className="w-6 h-6 text-primary" />
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Motivation